import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-unit-tagging-help-dialog',
  templateUrl: './unit-tagging-help-dialog.component.html',
  styleUrls: ['./unit-tagging-help-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatDialogActions]
})
export class UnitTaggingHelpDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<UnitTaggingHelpDialogComponent>>(MatDialogRef);

  close(): void {
    this.dialogRef.close();
  }
}
